import React from "react";
import { pure } from "recompose";

const HeaderForm = () => (
  <React.Fragment>
    <table style={{ width: "100%" }}>
      <tbody>
        <tr>
          <td style={{ width: 400 }}>
            <div
              style={{
                border: "2px solid #000",
                paddingLeft: 10,
                fontSize: 16,
                fontWeight: "bold",
              }}
            >
              GROUP INSURANCE
              <br />
              PERSONAL HEALTH DECLARATION FORM
            </div>
            <br />
            <div style={{ border: "1px solid #000", width: 300 }}>
              <table>
                <tbody>
                  <tr>
                    <td style={{ paddingLeft: 10, paddingRight: 20 }}>Policy No.</td>
                    <td>
                      <table style={{ borderCollapse: "collapse" }}>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ paddingLeft: 10, paddingRight: 20 }}>Date Sent</td>
                    <td>
                      <table style={{ borderCollapse: "collapse" }}>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                            <td
                              style={{
                                width: 20,
                                border: "1px solid #000",
                              }}
                            />
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
          <td style={{ textAlign: "right" }}>
            <img src="/assets/images/hdf/ge-logo.png" alt="" />
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <div
      style={{
        color: "#f00",
        fontWeight: "bold",
        fontSize: "10pt",
        padding: 10,
        borderTop: "2px solid #000",
        borderBottom: "2px solid #000",
      }}
    >
      Important Note: Pursuant to Section 25(5) of the Insurance Act (Cap. 142), you are to disclose
      in this form, fully and faithfully, all the facts <br />
      which you know or ought to know, otherwise, nothing may be payable under the Policy.
    </div>
    <div>
      <table>
        <tbody>
          <tr>
            <td
              style={{
                color: "#f00",
                fontSize: "10pt",
                padding: 10,
                fontWeight: "bold",
                width: 60,
              }}
            >
              NOTE:
            </td>
            <td style={{ color: "#f00", fontSize: "10pt", padding: 10 }}>
              <ol style={{ paddingLeft: 0 }}>
                <li>
                  All questions must be answered in ink. Dashes, strokes, ditto and N.A. are not
                  acceptable.
                </li>
                <li>Any alteration to the answers must be signed in full.</li>
                {/* <li style={{ fontWeight: "bold" }}>
                All pages must be signed by the Employee/Eligible Member.
              </li> */}
              </ol>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div style={{ fontWeight: "bold", paddingBottom: 10 }}>
      {'The "Company" shall mean The Great Eastern Life Assurance Company Limited.'}
    </div>
    <div style={{ display: "flex", fontWeight: "bold" }}>
      NAME OF POLICYHOLDER (EMPLOYER)
      <span style={{ marginLeft: 10, flexGrow: 1, borderBottom: "1px solid #000" }} />
    </div>
    <div
      style={{
        color: "#f00",
        fontWeight: "bold",
        fontSize: "10pt",
        borderBottom: "2px solid #000",
        paddingBottom: 5,
      }}
    />
    <div style={{ paddingBottom: 5 }} />
  </React.Fragment>
);

export default pure(HeaderForm);



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Ge/common/HeaderForm.js